const createRoutes = () => [
    {
        path: '/showroom/:name',
        exact: true,
        component: require('./pages/Showroom').default,
    },
];
export default createRoutes;
